"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDoctorsListApiResponseSchema = exports.getDoctorApiEntitySchema = exports.doctorEntityTypeSchema = void 0;
const zod_1 = require("zod");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
exports.doctorEntityTypeSchema = zod_1.z.enum([
    'doctor-substitutes',
    'doctor-attendings',
]);
exports.getDoctorApiEntitySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: exports.doctorEntityTypeSchema,
    attributes: zod_1.z.object({
        firstname: zod_1.z.string(),
        lastname: zod_1.z.string(),
        email: zod_1.z.string(),
        orderRegistrationNumber: zod_1.z.string(),
        thesis: zod_1.z.boolean(),
        createdAt: zod_1.z.coerce.date(),
        doctolibId: zod_1.z.string().nullable(),
    }),
});
exports.getDoctorsListApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.getDoctorApiEntitySchema);
